module.exports = __webpack_public_path__ + "img/banner_collect.dc98f2b6.png";